import React from "react";

const QuestionCard = ({ data, scoreObtained, isCompleted, completedBg }) => {
  function getDifficultyColor(difficulty) {
    switch (difficulty) {
      case "EASY":
        return "bg-green-200 text-gray-800";
      case "MEDIUM":
        return "bg-yellow-100 text-gray-800";
      case "HARD":
        return "bg-red-200 text-gray-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  }

  const difficulty =
    data?.difficulty?.charAt(0).toUpperCase() +
    data?.difficulty?.slice(1).toLowerCase();

  return (
    <div
      className="p-4 mb-4 border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
      style={completedBg ? { background: completedBg } : { background: "#fff" }}
    >
      <div className="flex justify-between items-start mb-2 flex-col md:flex-row">
        <div className="mb-2 md:mb-0">
          <div className="font-bold text-lg md:text-xl text-gray-900 flex items-center gap-2">
            {data.title}
            {isCompleted && (
              <span className="ml-2 px-2 py-0.5 text-xs font-semibold rounded bg-green-100 text-green-700 border border-green-300">Completed</span>
            )}
          </div>
          <div className="text-sm text-gray-500">Max Score: {data.marks}</div>
        </div>
        {data?.difficulty && (
          <div
            className={`p-1 text-xs text-center font-light rounded-md ${getDifficultyColor(
              data.difficulty
            )} md:self-start`}
          >
            {difficulty}
          </div>
        )}
      </div>

      <div className="flex justify-between items-center">
        <div className="flex flex-wrap gap-2 mb-2 md:mb-0">
          {data?.tags &&
            data.tags.map((tag, index) => (
              <span
                key={index}
                className="inline-block bg-blue-100 text-blue-800 rounded px-2 py-1 text-xs font-medium"
              >
                {tag}
              </span>
            ))}
        </div>
        {scoreObtained && isCompleted && (
          <div className="text-right max-md:text-left mt-2 max-md:mt-0 max-md:w-12 max-md:text-center">
            <div className="text-sm md:text-base text-gray-700 max-md:hidden">
              Obtained Marks:{" "}
              <span className="font-bold text-green-600">{scoreObtained}</span>
            </div>

            <div className="max-md:flex justify-center items-center max-md:bg-green-100 max-md:rounded-full max-md:py-1 max-md:text-green-600 lg:hidden">
              <span className="font-bold max-md:text-center">
                {scoreObtained}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionCard;
